import { defineStore } from 'pinia';
import loadNotionData from '@/api/NotionApi';
import type {
  PreconfiguredRobot,
  PriceList,
  SoftwareFeature,
} from '@/models/NotionResources';

const useNotionStore = defineStore('notion', {
  state: () => ({
    preconfiguredRobots: [] as PreconfiguredRobot[],
    softwareFeatures: [] as SoftwareFeature[],
    priceList: [] as PriceList[],
  }),
  getters: {},
  actions: {
    fetchNotionData() {
      loadNotionData().then((response) => {
        // Exclude Case Carl as this is only for internal use.
        // Besides, it contains legacy modules which will break the finder / virtual robot.
        this.preconfiguredRobots = response[0].data.filter(
          (robot: PreconfiguredRobot) => robot.EnglishName !== 'Case Carl',
        );
        this.softwareFeatures = response[1].data.sort(
          (a: SoftwareFeature, b: SoftwareFeature) => a.Number - b.Number,
        );
        this.priceList = response[2].data;
      });
    },
  },
});

export default useNotionStore;
